import { useTranslation } from 'react-i18next'

import { getManagerProfileOptions } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { toUserSelectItemsFromOption, UserMultiSelect } from '../../../../User'
import { REQUEST_FORM_FIELD_NAME_MANAGER } from '../../RequestForm.constants'
import { getAssigneeFieldErrorProps } from '../RequestFormFields.utils'

import * as styles from './AssigneeField.module.css'

function AssigneeField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      multi
      Component={FormFieldSelectNG}
      Select={UserMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Request.AssigneePlaceholderKey'),
          },
        },
      }}
      emptyValue={EMPTY_LIST}
      fieldComponentProps={{
        info: t('Request.ManagersInfoKey'),
        label: `${t('Request.AssigneeLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getManagerProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getAssigneeFieldErrorProps}
      name={REQUEST_FORM_FIELD_NAME_MANAGER}
      tagsProps={{
        className: styles.assigneeFieldTags,
      }}
      toPreparedItems={toUserSelectItemsFromOption}
    />
  )
}

export default AssigneeField
